// @flow

import { dispatch } from 'redux/store'
import { setVars } from 'redux/action'
import { get } from './lib/apiClient'
import fengPerf from 'feng-performance'

export function fetchVisitor () {
  return get('/gbltrade/api/v2/cms/getInfo').then(visitor => {
    fengPerf.Performance.setUid(visitor.id)
    dispatch(setVars('visitor', visitor))
    return visitor
  })
}



// WEBPACK FOOTER //
// ./src/projects/abroad/visitor.js